import { takeLatest } from 'redux-saga/effects';

import { MODAL_OPEN, MODAL_TOGGLE, MODAL_CLOSE } from "../types";

function* toggleModal() {
  const bodyTag = document.querySelector('body');
  yield bodyTag.classList.toggle('noscroll');
}

function* openModal() {
  if (typeof document !== 'undefined') {
    const bodyTag = document.querySelector('body');
    yield bodyTag.classList.add('noscroll');
  }
}

function* closeModal() {
  const bodyTag = document.querySelector('body');
  yield bodyTag.classList.remove('noscroll');
}

export default function* saga() {
  yield takeLatest(MODAL_TOGGLE, toggleModal);
  yield takeLatest(MODAL_OPEN, openModal);
  yield takeLatest(MODAL_CLOSE, closeModal);
}
